/* eslint-disable no-underscore-dangle */
/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import { BiddingData } from 'store/modules/bidding_store/types';
import Modal from 'react-bootstrap/Modal';
import { MarketBiddingTypes } from 'interfaces/market';
import { getMarketBiddings } from 'services/actions/market';
import Loader from 'components/atoms/loader';
import { BulletinBiddingsTypes } from 'store/modules/bulletins_store/types';
import { ContractItemTypes } from 'store/modules/contracts_store/types';
import { linkDaLicitacao } from 'services/market_links';
import { Table } from './styles';

interface ModalOrganDetailsProps {
  contract?: ContractItemTypes;
  bidding?: BiddingData | BulletinBiddingsTypes;
  setModalOrganDetailsOpened: React.Dispatch<React.SetStateAction<boolean>>;
}

const ModalOrganDetails = (props: ModalOrganDetailsProps) => {
  const { bidding, contract, setModalOrganDetailsOpened } = props;
  const [marketBiddingsLoaded, setMarketBiddingsLoaded] = useState<boolean>(false);
  const [marketBiddings, setMarketBiddings] = useState<Array<MarketBiddingTypes>>([]);
  const site_edital = bidding ? bidding?.edital_site : contract?._source?.orgao.edital_site;

  useEffect(() => {
    getMarketBiddings({
      organ_id: bidding ? bidding.public_body.id : Number(contract?._source?.orgao_id),
      setMarketBiddings,
      setMarketBiddingsLoaded,
    });
  }, []);

  return (
    <Modal size="lg" show>
      <div className="modal-header">
        <h6 className="modal-title" id="modalLabel">
          Órgão Público
        </h6>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => {
            setModalOrganDetailsOpened(false);
          }}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div className="modal-body">
        <div className="row">
          <div className="col-md-8">
            <p>
              <b>Nome</b> <br />{' '}
              {bidding?.public_body.nome ? bidding.public_body.nome : contract?._source?.orgao.nome}
            </p>
          </div>
          <div className="col-md-4">
            <p>
              <b>UASG</b> <br /> {bidding ? bidding?.orgao_uasg : contract?._source.orgao.uasg}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <p>
              <b>Endereço</b> <br />{' '}
              {bidding ? bidding?.orgao_endereco : contract?._source?.orgao.endereco}
            </p>
          </div>
          <div className="col-md-4">
            <p>
              <b>Cidade</b> <br />{' '}
              {bidding ? bidding?.orgao_cidade : contract?._source?.orgao.cidade}
            </p>
          </div>
          <div className="col-md-2">
            <p>
              <b>Estado</b> <br />{' '}
              {bidding ? bidding?.orgao_estado : contract?._source?.orgao.estado}
            </p>
          </div>
        </div>
        {site_edital !== '' && (
          <div className="row">
            <div className="col-md-12">
              <p>
                <b>Site</b>
                <br />
                <a
                  href={`${site_edital?.includes('http') ? site_edital : `http://${site_edital}`}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {site_edital}
                </a>
              </p>
            </div>
          </div>
        )}
        <hr />
        {!marketBiddingsLoaded && <Loader />}
        {marketBiddingsLoaded && (
          <div className="row">
            <Table className="col-md-12 mb-3">
              {marketBiddings.length === 1 && (
                <b>Total de {marketBiddings.length} resultado de licitações relacionadas</b>
              )}
              {marketBiddings.length !== 1 && (
                <b>Total de {marketBiddings.length} resultados de licitações relacionadas</b>
              )}
              <div className="position-relative box-table border rounded mt-3">
                <div className="row sticky-top font-weight-bold p-3 border-bottom table-header">
                  <div className="col-7">Objeto</div>
                  <div className="col-3">Edital</div>
                  <div className="col-2" />
                </div>
                {marketBiddings.map((marketBidding) => (
                  <div className="row p-3 border-bottom table-row">
                    <div className="col-7 table-text">{marketBidding.licitacao.objeto}</div>
                    <div className="col-3 table-text">{marketBidding.licitacao.edital}</div>
                    <div className="col-2 table-text text-center">
                      <a
                        className="btn btn-primary btn-sm"
                        href={linkDaLicitacao(marketBidding.licitacao.id)}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Acessar
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </Table>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ModalOrganDetails;
